<template>
  <div>
    <h2 class="kojin-title pc_only"><slot>タイトル</slot></h2>
  </div>
    <span class="sp_only">
      <span class="sp-title" style="color:#FFF;background: #4169e1;">
        <slot>タイトル</slot>
        
        <!-- ユーザー切替え対応 ユーザー名の表示とクリックした時にユーザー切替え画面を表示する -->
          <input type="text" class="form-control form-select" v-if="GlobalData.user_name && family_flg" v-bind:value="GlobalData.user_name" v-on:click="multipleusers_change" readonly="readonly">
          <input type="text" class="form-control" v-else-if="GlobalData.user_name && family_flg==false" v-bind:value="GlobalData.user_name" readonly="readonly">
          <input type="text" class="form-control" v-else-if="GlobalData.$profile" value="未登録" readonly="readonly">
          <input type="text" class="form-control" v-else value="----------------------------------------------------------------------------------" readonly="readonly">
          
      </span>
      
    <!-- 新規登録・ログインボタン（スマホのみ） -->
    <div class="sp_button_area" v-if="login_status == false" style="text-align:center;padding-bottom:10px;
      flex-direction: row;
        justify-content: center;">
      <button class="btn btn-primary mx-aut" style="font-size: 13.5px;width: 200px; height: 40px;margin:0 5px 10px 5px;padding: 0;background-color: #F5F5F5;color:#000;border:1px solid #000" v-on:click="user_signin()">新規登録</button>
      <br>
      <button class="btn btn-primary mx-aut" style="font-size: 13.5px;width: 200px; height: 40px;margin:0 5px 10px 5px;padding: 0;background-color: #F5F5F5;color:#000;border:1px solid #000" v-on:click="login()">ログイン</button>
     </div>

     <div class="sp_button_area" style="text-align:center;padding-bottom:10px;
        flex-direction: row;
        justify-content: center;"
        v-if="jizen_dsp == 1">
      <button class="btn btn-secondary mx-aut" style="font-size: 13.5px;width: 200px; height: 40px;margin:0 5px 10px 5px;padding: 0;background-color: #FF8400;color:white;border:1px solid #000" v-on:click="jizen_list()">事前説明会一覧</button>
      <br>
    </div>

    </span>
  <div class="p-2 " style="margin-top:0;background-color:white">
    
    
    <!-- ユーザー登録後アンケート未回答の場合（実施する場合のみ） -->
     <!-- 各文言はuserdata.jsより -->
     <div v-if="enqete_ok == 0" style="text-align:center">
     {{GlobalData.$enqete_mikaitou}}<br>
      <span v-on:click="move_enqete" style="color:red;cursor: pointer;"><u>{{GlobalData.$enqete_link}}</u></span><br>
      <hr style="width:100%">
    </div>
    <div v-if="midoku_count!=0" class="pc_only" style="color:red;cursor: pointer;" :onclick="move_notification">
      <u>
        未読のお知らせが {{midoku_count}} 件あります。
      </u>
     </div>

    <!-- パンくずリスト -->
    <nav class="pc_only" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" v-on:click="home" style="cursor:pointer">Home</li>{{ev}}
        <li class="breadcrumb-item active" aria-current="page"><slot>タイトル</slot></li>
      </ol>
    </nav>
    
    <div id="manual_area">

      <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />体験プログラムのマニュアル</span>
      <span class="pc_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>

    </div>

    <br clear="all">
    <div v-if="all_moshikomi_flg == 1"> 
      <template v-if="user_ok_jyokyo.length != 0">
        <!--すでに実績があるので申込可能-->
      </template>
      <template v-else-if="all_moshikomi_count > now_moshikomi_count">
        あと <b>{{all_moshikomi_count - now_moshikomi_count}} 人</b> 申込可能
      </template>
      <template v-else>
        <b style="color:red">この社協では、これ以上お申込みできません。</b>
      </template>
    </div>

    <div class="sp_only" style="text-align:center;padding: 5px;text-align: left;font-size: 0.9rem;">
      <span style="color:red">プログラム番号：名称をタップしてください。</span><br>
      （<span style="color:#4169e1">青枠下線部</span>）
     </div>
    <!-- PC時は全件数、ページ選択、表示件数を表示 -->
  <div class="pg_list_page" style="padding: 0 5px;">

    <div style="width:25%">
      <span style="display:flex;align-items: center;"><b style="font-size: 20px;padding-right: 5px">{{ kensu }}</b> 件見つかりました</span>
    </div>

    <div style="width:50%;display: flex;justify-content: center;align-items: center;margin:0 auto">
        <div style="float:left;cursor:pointer" v-on:click="top">最初へ&nbsp;&nbsp;</div>
        <div style="float:left;cursor:pointer" v-on:click="back">前へ&nbsp;&nbsp;</div>
        <div v-for="i in tm" :key="i" style="float:left;cursor:pointer" v-on:click="page(i)">&nbsp;{{i}}&nbsp;</div>
        <div style="float:left;cursor:pointer" v-on:click="forward">&nbsp;&nbsp;次へ</div>
        <div style="float:left;cursor:pointer" v-on:click="last">&nbsp;&nbsp;最後へ</div>
    </div>
    
    <div style="width:25%;display: flex;align-items: center;justify-content: flex-end;">
      
      <span style="display:flex;float: right;">
        表示件数：
        <select v-model="gyo_count" v-on:change="gyo_change">
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="30">30</option>
          <option value="40">40</option>
          <option value="50">50</option>
        </select>
      </span>
    </div>
  </div>

    
  <!--スマホ時は件数のみ表示-->
  <div class="sp_only" style="width:100%;padding-left:5px;">
      <span style="display:flex;align-items: center;">検索結果 <b style="padding:0 10px">{{ kensu }}</b> 件</span>
  </div>

    <!-- 体験プログラム概要 -->
    <div align="left" v-for="(pg,i) in program.slice(st-1,ed)" v-bind:key="pg.id">
    <div class="hov" style="padding:4px;margin-bottom: 12px;">
      <table border="1" rules="all"  style="width:100%;border-collapse:collapse;cursor:pointer">
                <tr v-on:click="shosai(i,pg.teiin_flg)">
                  <td style="font-size:14px;background-color:white;display:flex;align-items: center;justify-content: space-between;">
                    <div style="float:left" :style="{ color: list_color[0] ,fontWeight:list_bold[0] == '0' ? 400 : 700 }"><b>{{pg.bunrui1 }}</b><br>
                      <span v-if="list_disp[1] == 1 && pg.bunrui2 != 'なし'"
                      :style="{ color: list_color[1] ,fontWeight:list_bold[1] == '0' ? 400 : 700 }"> {{pg.bunrui2 }} </span>
                    </div>
                    <!--満員より受付終了の表示が優先-->
                      <template v-if="all_over(pg,sub[i + ((current_page -1 ) * gyo_count)],nittei[i + ((current_page -1 ) * gyo_count)],sub_nittei[i + ((current_page -1 ) * gyo_count)],pg,sub[i + ((current_page -1 ) * gyo_count)]) == true">
                        <img  src="../../images/end.png" alt="受付〆切" style="height:45px" />
                      </template>
                      <div v-else-if="teiin_over(nittei[i + ((current_page -1 ) * gyo_count)],sub_nittei[i + ((current_page -1 ) * gyo_count)],pg,sub[i + ((current_page -1 ) * gyo_count)]) == true" style="float:right">
                          
                        <!--
                        cancel_count = response["data"].cancel_count
                        cancel_day = response["data"].cancel_day
                        cancel_setting = response["data"].cancel_setting

                        キャンセル可能回数が0、または、キャンセル待ち機能の利用が1（利用しない）の場合は、定員なら満員御礼を出す
                        -->
                        <template v-if="cancel_count != 0 || cancel_setting == 1">
                          
                          <img  src="../../images/max2.png" alt="満員御礼" style="height:45px" />
                        </template>
                      </div>
                  </td>
                </tr>
                <tr v-on:click="shosai(i,pg.teiin_flg)"><td style="padding:2pt 6pt;background-color:royalblue;color:white;border-bottom: 1px solid #FFF;display: flex;justify-content: flex-start;align-items: center;">
                  <div style="font-size:20px;">
                    <u :style="{ color: list_color[2] != 'black' ? list_color[2] : white ,fontWeight:list_bold[2] == '0' ? 400 : 700 }">
                      {{ pg.taiken_no_text }}：{{pg.name }}
                    </u>
                  </div>
                </td></tr>
                <template v-if="sub[i + ((current_page -1 ) * gyo_count)]">
                  <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="sub[i + ((current_page -1 ) * gyo_count)].length != 0">
                    <td style="font-size:16px;padding:5pt;background-color:linen;" border="1">
                      <b style="display: flex;align-items: center;">【活動1】
                      <template v-if="over(pg,nittei[i + ((current_page -1 ) * gyo_count)]) == true">
                        <img  src="../../images/end.png" alt="受付〆切" style="height:25px" />
                      </template>
                      </b>
                    </td>
                  </tr>
                </template>

                <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[9] == 1 && pg.k_name != '' && pg.k_name != null">
                  <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                    <div   style="display: flex;align-items: center;">
                      <b class="pc_only midashi_pc">開催地名</b>
                      <b class="sp_only midashi_sp">開催地名</b>
                      <div class="program_naiyo" :style="{ color: list_color[9] ,fontWeight:list_bold[9] == '0' ? 400 : 700 }">{{pg.k_name}}</div>
                    </div>
                  </td>

                </tr>
                <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[3] == 1">
                  <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                    <div   style="display: flex;align-items: center;">
                      <b class="pc_only midashi_pc">施設住所</b>
                      <b class="sp_only midashi_sp">施設住所</b>
                      <div class="program_naiyo" :style="{ color: list_color[3] ,fontWeight:list_bold[3] == '0' ? 400 : 700 }">{{pg.k_jusyo}}</div>
                    </div>
                  </td>

                </tr>
                <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[11] == 1 && pg.k_access != '' && pg.k_access != null">
                  <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                    <div   style="display: flex;align-items: center;">
                      <b class="pc_only midashi_pc">アクセス方法</b>
                      <b class="sp_only midashi_sp">アクセス方法</b>
                      <div class="program_naiyo" :style="{ color: list_color[11] ,fontWeight:list_bold[11] == '0' ? 400 : 700 }">{{pg.k_access}}</div>
                    </div>
                  </td>

                </tr>
                <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[10] == 1 && pg.k_tel != '' && pg.k_tel != null">
                  <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                    <div   style="display: flex;align-items: center;">
                      <b class="pc_only midashi_pc">連絡先</b>
                      <b class="sp_only midashi_sp">連絡先</b>
                      <div class="program_naiyo" :style="{ color: list_color[10] ,fontWeight:list_bold[10] == '0' ? 400 : 700 }">{{pg.k_tel}}</div>
                    </div>
                  </td>

                </tr>
                <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[4] == 1">
                  <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                    <div style="display: flex;align-items: center;">
                      
                      <b class="pc_only midashi_pc">活動内容</b>
                      <b class="sp_only midashi_sp">活動内容</b>
                      <div class="program_naiyo" :style="{ color: list_color[4] ,fontWeight:list_bold[4] == '0' ? 400 : 700 }" style="white-space: pre-wrap;">{{pg.naiyou}}</div>
                    </div>
                  </td>

                </tr>
                
                <template v-if="pg.shubetsu == 2">
                  <!--届け先は種別＝2（制作・寄付）の時のみ-->
                  <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[12] == 1 && pg.todokesaki != '' && pg.todokesaki != null">
                    <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                      <div style="display: flex;align-items: center;">
                        <b class="pc_only midashi_pc">届け先</b>
                        <b class="sp_only midashi_sp">届け先</b>
                        <div class="program_naiyo" :style="{ color: list_color[12] ,fontWeight:list_bold[12] == '0' ? 400 : 700 }">{{pg.todokesaki}}</div>
                      </div>
                    </td>
                  </tr>
                </template>

                
                
                <template v-for="(result,i2) in nittei[i + ((current_page -1 ) * gyo_count)]" v-bind:key="i2">
                <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[5] == 1">
                  <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                    <div style="display: flex;align-items: center;">
                      <span v-if="i2 != 0"></span>
                      
                        <template v-if="pg.shubetsu == 1">

                          <template  v-if="nittei[i + ((current_page -1 ) * gyo_count)].length == 1">
                            <b class="pc_only midashi_pc">日程</b>
                            <b class="sp_only midashi_sp">日程</b>
                          </template>
                          <template v-else>
                            <b class="pc_only midashi_pc">日程{{ (i2+1) }}</b>
                            <b class="sp_only midashi_sp">日程{{ (i2+1) }}</b>

                          </template>
                            <div class="program_naiyo" :style="{ color: list_color[5] ,fontWeight:list_bold[5] == '0' ? 400 : 700 }">
                              
                              <b>開催日：</b>{{DateSetting(result.kaisai_start)}} <span v-if="result.kaisai_end && result.kaisai_end != result.kaisai_start">～{{DateSetting(result.kaisai_end)}}</span><br>
                             
                                  <span v-for="(jikantai,j) in result.jikantai_list" v-bind:key="j">
                                    
                                      <hr style="margin:1px 0" v-if="result.jikantai_list.length > 1">
                                     <div style="display: flex;align-items: center;flex-direction: row;">
                                      <b>時間帯<template v-if="result.jikantai_list.length > 1">{{j+1}}</template>：</b>
                                      <div>
                                          <span v-if="jikantai.jikantai_start">{{TimeSetting(jikantai.jikantai_start)}} ～ {{TimeSetting(jikantai.jikantai_end)}}</span>
                                          <template v-if="pg.teiin_settei == 0">
                                            <br>
                                            <b style="margin-right:5px">定員</b>
                                            
                                                    <template v-if="jikantai.teiin_mongon != '' && jikantai.teiin_mongon != null">
                                                      {{jikantai.teiin_mongon}}
                                                    </template>
                                                    <template v-else>
                                                      <span v-if="jikantai.teiin >= 999">無し</span><span v-else-if="result.teiin">{{jikantai.teiin}} 名まで</span>
                                                    </template>
                                          </template>
                                        </div>
                                    </div>
                                    <template v-if="result.jikantai_list.length > 1 && (result.kaisai_youbi != null || result.jogai != null || result.jogai_date != null || result.comment != null)">
                                      <hr style="margin:1px 0" v-if="(j == result.jikantai_list.length - 1) ">
                                    </template>
                                  </span>
                                  
                              <span v-if="(result.kaisai_youbi != null)"><b>開催曜日：</b>{{youbi_irekae(result.kaisai_youbi)}} <br></span>
                              <span v-if="(result.jogai != null)"><b>除外曜日：</b>{{youbi_irekae(result.jogai)}} <br></span>
                              <span v-if="(result.jogai_date != null)"><b>除外日：</b>{{result.jogai_date}} <br></span>
                              <span v-if="(result.comment != null)"><b>コメント：</b>{{ result.comment }}</span>
                            </div>
                        </template>
                        <template v-else>
                              
                            <b class="pc_only midashi_pc">開催期間</b>
                            <b class="sp_only midashi_sp">開催期間</b>
                            <div class="program_naiyo" :style="{ color: list_color[5] ,fontWeight:list_bold[5] == '0' ? 400 : 700 }">
                              {{DateSetting(result.kaisai_start)}} <span v-if="result.kaisai_end && result.kaisai_end != result.kaisai_start">～{{DateSetting(result.kaisai_end)}}</span><br>

                            </div>
                        </template>
                    </div>
                  </td>
                </tr>
              </template>
              <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[13] == 1 && pg.bikou !='' && pg.bikou != null">
                  <td style="font-size:14px;padding:1pt 6pt;background-color:linen;white-space: pre-wrap;" border="1">
                    <div style="display: flex;align-items: center;">
                      
                      <b class="pc_only midashi_pc">特記事項</b>
                      <b class="sp_only midashi_sp">特記事項</b>
                      <div class="program_naiyo" :style="{ color: list_color[13] ,fontWeight:list_bold[13] == '0' ? 400 : 700 }">{{pg.bikou}}</div>
                    </div>
                  </td>

                </tr>
                <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="pg.shubetsu==1 && list_disp[6] == 1 && pg.nittei_sentaku == 0">
                  <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                    
                      
                      <div style="display: flex;align-items: center;">
                        <template  v-if="(pg.nissu_min != '' || pg.nissu_min != null ) && (pg.nissu_max != '' || pg.nissu_max != null ) ">
                        <b class="pc_only midashi_pc">活動日数</b>
                        <b class="sp_only midashi_sp">活動日数</b>
                        <div class="program_naiyo" :style="{ color: list_color[6] ,fontWeight:list_bold[6] == '0' ? 400 : 700 }">
                           <template v-if="pg.nissu_mongon != '' && pg.nissu_mongon != null">
                             {{pg.nissu_mongon}}
                          </template>
                          <template v-else>
                          <span v-if=" pg.nissu_min == pg.nissu_max ">
                            {{ pg.nissu_min  }}日
                          </span>
                          <span v-else-if="pg.nissu_min != pg.nissu_max ">
                            <span v-if="pg.nissu_max == '' || pg.nissu_max == null ">
                              {{ pg.nissu_min  }}日以上
                            </span>
                            <span v-else-if="pg.nissu_min == '' || pg.nissu_min == null ">
                              {{ pg.nissu_max  }}日以下
                            </span>
                            <span v-else>
                              {{pg.nissu_min}} ～ {{pg.nissu_max}}日
                            </span>
                            </span>&nbsp;&nbsp;
                            <span v-if="pg.nissu_joken == 1">連続</span>
                            </template>
                        </div>
                      </template>
                      </div>

                    </td>

                  </tr>
                  <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="pg.teiin_settei == 1">
                  <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                    <div style="display: flex;align-items: center;">
                      
                      <b class="pc_only midashi_pc">定員</b>
                      <b class="sp_only midashi_sp">定員</b>
                      <div class="program_naiyo" :style="{ color: list_color[5] ,fontWeight:list_bold[5] == '0' ? 400 : 700 }">
                        
                          <template v-if="pg.teiin_mongon != '' || pg.teiin_mongon != null">
                              {{ pg.teiin_mongon }}
                          </template>
                          <template v-else>
                              {{ pg.teiin_oneday }}&nbsp;名まで&nbsp;
                          </template>
                      </div>
                    </div>
                  </td>

                </tr>
                  <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[7] == 1">
                    <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                      <div style="display: flex;align-items: center;">
                      <b class="pc_only midashi_pc">参加条件</b>
                      <b class="sp_only midashi_sp">参加条件</b>
                      <div class="program_naiyo" :style="{ color: list_color[7] ,fontWeight:list_bold[7] == '0' ? 400 : 700 }">

                         <template v-if="pg.joken_mongon != '' && pg.joken_mongon != null">
                            {{pg.joken_mongon }}
                         </template>
                         <template v-else>
                            {{createJokenText(pg.joken_all_start,pg.joken_all_end)}}
                         </template>
                        
                        
                      </div>
                    </div>
                  </td>

                </tr>
                <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[8] == 1">
                  
                  <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                    
                    <div style="display: flex;align-items: center;">
                      <b class="pc_only midashi_pc">申込〆切</b>
                      <b class="sp_only midashi_sp">申込〆切</b>
                      <div class="program_naiyo" :style="{ color: list_color[8] ,fontWeight:list_bold[8] == '0' ? 400 : 700 }">
                        
                        <!--
                        〆切日パターン
                        1:事業単位で〆切日を設定（end_shubetsu == 1）＝事業全体の受付〆切日
                        2:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日を設定している＝プログラムの受付〆切日
                        3:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日が設定されていない＝申込日の〇日前まで申込可能
                        -->
                        <template v-if="end_shubetsu == 1">
                          {{DateTimeSetting(end_datetime)}}
                        </template>
                        <template v-else-if="pg.shimekiri_date">{{EuDateTimeSetting(pg.shimekiri_date)}}</template>
                        <template v-else>開催日の{{pg.shimekiri_nissu}}日前まで申込可能</template>
                        <template v-if="over(pg,nittei[i + ((current_page -1 ) * gyo_count)]) == true">
                          <br><b style="color:red;">受付は終了しました。</b>
                       </template>
                      </div>
                    </div>
                  </td>
              
                </tr>

                <template v-if="sub[i + ((current_page -1 ) * gyo_count)]">
                <template v-if="sub[i + ((current_page -1 ) * gyo_count)].length != 0">
                  <!-- サブプログラムがある場合 -->
                  <template v-for="(spg,s) in sub[i + ((current_page -1 ) * gyo_count)]" v-bind:key="s">
                    <hr style="margin:0">
                    <tr v-on:click="shosai(i,pg.teiin_flg)" >
                      <td style="font-size:16px;padding:5pt;background-color:linen;" border="1">
                        <b style="display: flex;align-items: center;">【活動{{s+2}}】
                          
                        <template v-if="over(spg,sub_nittei[i + ((current_page -1 ) * gyo_count)][s]) == true">
                          <img  src="../../images/end.png" alt="受付〆切" style="height:25px" />
                        </template>
                        </b>
                        
                      </td>
                    </tr>

                    <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[9] == 1 && spg.k_name != '' && spg.k_name != null">
                      <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                        <div style="display: flex;align-items: center;">
                          <b class="pc_only midashi_pc">開催地名</b>
                          <b class="sp_only midashi_sp">開催地名</b>
                          <div class="program_naiyo" :style="{ color: list_color[9] ,fontWeight:list_bold[9] == '0' ? 400 : 700 }">{{spg.k_name}}</div>
                        </div>
                      </td>

                    </tr>
                    <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[3] == 1">
                      <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                        <div   style="display: flex;align-items: center;">
                          <b class="pc_only midashi_pc">施設住所</b>
                          <b class="sp_only midashi_sp">施設住所</b>
                          <div class="program_naiyo" :style="{ color: list_color[3] ,fontWeight:list_bold[3] == '0' ? 400 : 700 }">{{spg.k_jusyo}}</div>
                        </div>
                      </td>

                    </tr>
                    <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[11] == 1 && spg.k_access != '' && spg.k_access != null">
                      <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                        <div   style="display: flex;align-items: center;">
                          <b class="pc_only midashi_pc">アクセス方法</b>
                          <b class="sp_only midashi_sp">アクセス方法</b>
                          <div class="program_naiyo" :style="{ color: list_color[11] ,fontWeight:list_bold[11] == '0' ? 400 : 700 }">{{spg.k_access}}</div>
                        </div>
                      </td>

                    </tr>
                    <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[10] == 1 && spg.k_tel != '' && spg.k_tel != null">
                      <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                        <div   style="display: flex;align-items: center;">
                          <b class="pc_only midashi_pc">連絡先</b>
                          <b class="sp_only midashi_sp">連絡先</b>
                          <div class="program_naiyo" :style="{ color: list_color[10] ,fontWeight:list_bold[10] == '0' ? 400 : 700 }">{{spg.k_tel}}</div>
                        </div>
                      </td>

                    </tr>
                    <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[4] == 1">
                      <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                        <div style="display: flex;align-items: center;">
                          
                          <b class="pc_only midashi_pc">活動内容</b>
                          <b class="sp_only midashi_sp">活動内容</b>
                          <div class="program_naiyo" :style="{ color: list_color[4] ,fontWeight:list_bold[4] == '0' ? 400 : 700 }" style="white-space: pre-wrap;">{{spg.naiyou}}</div>
                        </div>
                      </td>

                    </tr>
                    
                    <template v-if="pg.shubetsu == 2">
                      <!--届け先は種別＝2（制作・寄付）の時のみ-->
                      <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[12] == 1 && spg.todokesaki != '' && spg.todokesaki != null">
                        <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                          <div style="display: flex;align-items: center;">
                            <b class="pc_only midashi_pc">届け先</b>
                            <b class="sp_only midashi_sp">届け先</b>
                            <div class="program_naiyo" :style="{ color: list_color[12] ,fontWeight:list_bold[12] == '0' ? 400 : 700 }">{{spg.todokesaki}}</div>
                          </div>
                        </td>
                      </tr>
                    </template>
                    
                   
                    
                    <template v-for="(sub_array,s2) in sub_nittei[i + ((current_page -1 ) * gyo_count)]" v-bind:key="s2">
                      <template v-for="(result,i2) in sub_array" v-bind:key="i2">
                        <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[5] == 1 && ( spg.taiken_id == result.taiken_id)">
                          <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                            <div style="display: flex;align-items: center;">
                              <span v-if="i2 != 0"></span>
                                <template v-if="pg.shubetsu == 1">

                                  <template  v-if="sub_array.length == 1">
                                    <b class="pc_only midashi_pc">日程</b>
                                    <b class="sp_only midashi_sp">日程</b>
                                  </template>
                                  <template v-else>
                                    <b class="pc_only midashi_pc">日程{{ (i2+1) }}</b>
                                    <b class="sp_only midashi_sp">日程{{ (i2+1) }}</b>

                                  </template>
                                    <div class="program_naiyo" :style="{ color: list_color[5] ,fontWeight:list_bold[5] == '0' ? 400 : 700 }">
                                      
                                      <b>開催日：</b>{{DateSetting(result.kaisai_start)}} <span v-if="result.kaisai_end && result.kaisai_end != result.kaisai_start">～{{DateSetting(result.kaisai_end)}}</span><br>

                                          <span v-for="(jikantai,j) in result.jikantai_list" v-bind:key="j">
                                            
                                              <hr style="margin:1px 0" v-if="result.jikantai_list.length > 1">
                                            <div style="display: flex;align-items: center;flex-direction: row;">
                                              
                                                <b>時間帯<template v-if="result.jikantai_list.length > 1">{{j+1}}</template>：</b>
                                                <div>

                                                  <span v-if="jikantai.jikantai_start">{{TimeSetting(jikantai.jikantai_start)}} ～ {{TimeSetting(jikantai.jikantai_end)}}</span>
                                                  <template v-if="spg.teiin_settei == 0">
                                                    <br>
                                                    <b  style="margin-right:5px">定員</b>
                                                    
                                                    <template v-if="jikantai.teiin_mongon != '' && jikantai.teiin_mongon != null">
                                                      {{jikantai.teiin_mongon}}
                                                    </template>
                                                    <template v-else>
                                                      <span v-if="jikantai.teiin >= 999">無し</span><span v-else-if="result.teiin">{{jikantai.teiin}} 名まで</span>
                                                    </template>
                                                  </template>
                                                </div>
                                              </div>
                                              <template v-if="result.jikantai_list.length > 1 && (result.kaisai_youbi != null || result.jogai != null || result.jogai_date != null || result.comment != null)">
                                                <hr style="margin:1px 0" v-if="(j == result.jikantai_list.length - 1) ">
                                              </template>
                                            </span>
                                      <span v-if="(result.kaisai_youbi != null)"><b>開催曜日：</b>{{youbi_irekae(result.kaisai_youbi)}} <br></span>
                                      <span v-if="(result.jogai != null)"><b>除外曜日：</b>{{youbi_irekae(result.jogai)}} <br></span>
                                      <span v-if="(result.jogai_date != null)"><b>除外日：</b>{{result.jogai_date}} <br></span>
                                      <span v-if="(result.comment != null)"><b>コメント：</b>{{ result.comment }}</span>
                                    </div>
                                </template>
                                <template v-else>
                                      
                                    <b class="pc_only midashi_pc">開催期間</b>
                                    <b class="sp_only midashi_sp">開催期間</b>
                                    <div class="program_naiyo" :style="{ color: list_color[5] ,fontWeight:list_bold[5] == '0' ? 400 : 700 }">
                                      {{DateSetting(result.kaisai_start)}} <span v-if="result.kaisai_end && result.kaisai_end != result.kaisai_start">～{{DateSetting(result.kaisai_end)}}</span><br>

                                    </div>
                                </template>
                            </div>
                          </td>
                        </tr>
                    </template>
                  </template>
                  <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[13] == 1 && spg.bikou !='' && spg.bikou != null">
                      <td style="font-size:14px;padding:1pt 6pt;background-color:linen;white-space: pre-wrap;" border="1">
                        <div style="display: flex;align-items: center;">
                          
                          <b class="pc_only midashi_pc">特記事項</b>
                          <b class="sp_only midashi_sp">特記事項</b>
                          <div class="program_naiyo" :style="{ color: list_color[13] ,fontWeight:list_bold[13] == '0' ? 400 : 700 }">{{spg.bikou}}</div>
                        </div>
                      </td>

                    </tr>
                    <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="pg.shubetsu==1 && list_disp[6] == 1 && spg.nittei_sentaku == 0">
                      <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                        
                          
                          <div style="display: flex;align-items: center;">
                            <template  v-if="(spg.nissu_min != '' || spg.nissu_min != null ) && (spg.nissu_max != '' || spg.nissu_max != null ) ">
                            <b class="pc_only midashi_pc">活動日数</b>
                            <b class="sp_only midashi_sp">活動日数</b>
                            <div class="program_naiyo" :style="{ color: list_color[6] ,fontWeight:list_bold[6] == '0' ? 400 : 700 }">
                              <template v-if="spg.nissu_mongon != '' && spg.nissu_mongon != null">
                              {{spg.nissu_mongon}}
                            </template>
                            <template v-else>
                              <span v-if=" spg.nissu_min == spg.nissu_max ">
                              {{ spg.nissu_min  }}日
                            </span>
                            <span v-else-if="spg.nissu_min != spg.nissu_max ">
                              <span v-if="pg.nissu_max == '' || spg.nissu_max == null ">
                                {{ spg.nissu_min  }}日以上
                              </span>
                              <span v-else-if="spg.nissu_min == '' || spg.nissu_min == null ">
                                {{ spg.nissu_max  }}日以下
                              </span>
                              <span v-else>
                                {{ spg.nissu_min }} ～ {{ spg.nissu_max }}日
                              </span>
                              </span>&nbsp;&nbsp;
                              <span v-if="spg.nissu_joken == 1">連続</span>
                            </template>
                            </div>
                          </template>
                          </div>

                        </td>

                      </tr>
                       <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="spg.teiin_settei == 1">
                      <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                        <div style="display: flex;align-items: center;">
                          
                          <b class="pc_only midashi_pc">定員</b>
                          <b class="sp_only midashi_sp">定員</b>
                          <div class="program_naiyo" :style="{ color: list_color[5] ,fontWeight:list_bold[5] == '0' ? 400 : 700 }">
                          <template v-if="spg.teiin_mongon != '' || spg.teiin_mongon != null">
                              {{ spg.teiin_mongon }}
                          </template>
                          <template v-else>
                              {{ spg.teiin_oneday }}&nbsp;名まで&nbsp;
                          </template>
                          </div>
                        </div>
                      </td>

                    </tr>
                      <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[7] == 1">
                        <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                          <div style="display: flex;align-items: center;">
                          <b class="pc_only midashi_pc">参加条件</b>
                          <b class="sp_only midashi_sp">参加条件</b>
                          <div class="program_naiyo" :style="{ color: list_color[7] ,fontWeight:list_bold[7] == '0' ? 400 : 700 }">
                            
                            <template v-if="spg.joken_mongon != '' && spg.joken_mongon != null">
                                {{spg.joken_mongon }}
                            </template>
                            <template v-else>
                                {{createJokenText(spg.joken_all_start,spg.joken_all_end)}}
                            </template>
                        
                          </div>
                        </div>
                      </td>

                    </tr>
                    <tr v-on:click="shosai(i,pg.teiin_flg)" v-if="list_disp[8] == 1">
                      
                      <td style="font-size:14px;padding:1pt 6pt;background-color:linen;" border="1">
                        
                        <div style="display: flex;align-items: center;">
                          <b class="pc_only midashi_pc">申込〆切</b>
                          <b class="sp_only midashi_sp">申込〆切</b>
                          <div class="program_naiyo" :style="{ color: list_color[8] ,fontWeight:list_bold[8] == '0' ? 400 : 700 }"> 
                            
                            <!--
                            〆切日パターン
                            1:事業単位で〆切日を設定（end_shubetsu == 1）＝事業全体の受付〆切日
                            2:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日を設定している＝プログラムの受付〆切日
                            3:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日が設定されていない＝申込日の〇日前まで申込可能
                            -->
                            <template v-if="end_shubetsu == 1">
                              {{DateTimeSetting(end_datetime)}}
                            </template>
                            <template v-else-if="spg.shimekiri_date">{{EuDateTimeSetting(spg.shimekiri_date)}}</template>
                            <template v-else>開催日の{{spg.shimekiri_nissu}}日前まで申込可能</template>
                            <template v-if="over(spg,sub_nittei[i + ((current_page -1 ) * gyo_count)][s]) == true">
                              <br><b style="color:red;">受付は終了しました。</b>
                            </template>
                            
                          </div>
                        </div>
                      </td>
                  
                    </tr>
                  </template>
                  
                </template>
                </template>
              </table>
    </div>
    </div><br/>
    
    <div class="pg_list_page" style="width:100%;justify-content: center;margin:0 auto">
        <div style="float:left;cursor:pointer" v-on:click="top">最初へ&nbsp;&nbsp;</div>
        <div style="float:left;cursor:pointer" v-on:click="back">前へ&nbsp;&nbsp;</div>
        <div v-for="i in tm" :key="i" style="float:left;cursor:pointer" v-on:click="page(i)">&nbsp;{{i}}&nbsp;</div>
        <div style="float:left;cursor:pointer" v-on:click="forward">&nbsp;&nbsp;次へ</div>
        <div style="float:left;cursor:pointer" v-on:click="last">&nbsp;&nbsp;最後へ</div>
    </div><br/>
  </div>
     
      <!--メッセージを表示するモーダルウィンドウ-->
      <component v-bind:is="contentMessage"
                v-bind:message_text="message"
                v-bind:message_cat="message_cat"
                v-bind:message_flag="message_flag"
                @close_message="Close_message"
                @ok_message="OK_message"/>

            
</template>

<script setup>
/* eslint-disable */ 
import { useRouter,useRoute } from 'vue-router'
import { DateSetting,DateTimeSetting,TimeSetting,ShimekiriSetting,EuDateTimeSetting,EuShimekiriSetting,youbi_irekae,GlobalData } from '../js/userdata.js'

import axios from 'axios'
import { ref, computed, watch } from 'vue';
/* メッセージを表示するモーダルウィンドウ */
import MessageModal from '../common/MessageModal.vue'  

let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ

/* 表示する子コンポーネント関係の情報 */
const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
contentMessage.value = null // 表示する子コンポーネント

import { useStore } from 'vuex'
const store = useStore()
let current_page = ref(store.state.current_page)
//const fileInput = ref(null);
const router = useRouter()
const route = useRoute()

const prop = defineProps(['param'])
let program = ref(prop.param.program) // 表示するプログラム

let kensu = 0
  if(program.value.length != 0){
    kensu = program.value[0].all_count
    console.log(program.value[0])
  }
let nittei = prop.param.nittei
let sub = prop.param.sub
let sub_nittei = prop.param.sub_nittei
let holiday_list = prop.param.holiday_list 

let disp_nittei = ref([])

//const cityname = prop.param.cityname
const cityname = route.params.shakyo

const midoku_count = ref(prop.param.midoku_count)

// ユーザーが本来所属する社協の名前
let shozoku_name = ref(prop.param.shozoku_name)

// 事業全体の体験プログラム参加者
let Sankasha = prop.param.Sankasha

let family_flg = ref(false)  // 家族フラグ(家族の登録が出来る)が設定されている時は、右メニューのボタンが表示される

let family_flg_get_error = 0
const family_flg_get = () => {
    let res = null
    axios.post(GlobalData.$API_URL+"TaikenAccountUser_read", {taikenuser_id:GlobalData.user_id})
    .then(response => {
        
        if(response.data.accountuser){
            res = response.data.accountuser
            family_flg.value = res['family']

        } else {
            family_flg.value = false
        }
    })
    .catch(error => {
        if(family_flg_get_error == 6){
            alert(error + GlobalData.$axios_error)
        }else{
            family_flg_get_error++
            setTimeout(function(){family_flg_get()},"1000")
        }
        
    })
}

family_flg_get()

// アンケート回答済みかどうか（0：未回答、1：回答済み、2：回答の必要なし）
let enqete_ok = ref(2)

    let Form_answer_check = function() { 
        
            let set_url = GlobalData.$API_URL+ "Form_Dynamo_read"
            axios.post(set_url,
            {
                action:"get_form_answers",
                choson_code:route.params.shakyo,
                taikenuser_id:GlobalData.user_id
            }) 
            .then(response => {

            

              // フラグを一度未回答状態にする
              GlobalData.enqete_flg = 0
              enqete_ok.value = 0

                for(let i = 0;i<response.data.data.length;i++){
                    let form_data = response.data.data[i]
                    // 種類がアンケート、かつ、フォームNo.が1（ユーザー登録後アンケート）なら回答済みと判断
                    if(form_data.syurui == "enqete" && form_data.form_no == 1){
                        GlobalData.enqete_flg = 1
                        enqete_ok.value = 1
                    }
                }

            })
            .catch(error => {
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "get_error";
                contentMessage.value = MessageModal
            })
    }
    
// 総申込者数に関する情報
let all_moshikomi_flg = ref(0) // 総申込者数を利用するかどうか　1：利用する、2：しない
let all_moshikomi_count = ref(1000) // 総申込者数の上限
let now_moshikomi_count = ref(0) // 現在の総申込者数

// 今日の日付
let today = new Date()

// 受付〆切日の種別（1:事業単位、2:プログラム単位）
let end_shubetsu = ref(1)
// 受付〆切日時
let end_datetime = ref(new Date(today.getFullYear()+"-"+(today.getMonth()+1)+"-"+today.getDate()+" 23:59:59"))


// 申込み可能回数を利用するかどうか（1:する、2:しない）
let program_shubetsu = ref(2)

// 申込み可能回数
let program_count = ref(5)


const emit = defineEmits(['call'])

// ログイン状態
let login_status = ref(true)
    

  // 一覧表示フラグ、文字色、太さ
  // 分類1（固定） 0
  // 分類2 1
  // プログラム名（固定）2
  // 施設住所 3
  // 活動内容 4
  // 日程 5
  // 活動日数 6
  // 参加条件 7
  // 申込〆切 8
  // 開催地名 9
  // 連絡先 10
  // アクセス方法 11
  // 届け先（制作・寄付のみ） 12
  // 特記事項　13
  let list_disp = ref([0,0,0,0,0,0,0,0,0,0,0,0,0,0])
  let list_color = ref(['black','black','black','black','black','black','black','black','black','black','black','black','black','black'])
  let list_bold = ref([0,0,0,0,0,0,0,0,0,0,0,0,0,0])

// 社協名
let shakyo_name = "";

// キャンセルに関する情報
let cancel_count = 0 // 申込キャンセル可能回数 0はキャンセル不可
let cancel_day = 1 // 申込キャンセル可能日数
let cancel_setting = 0 // キャンセル待ち機能 0：利用する、1：しない


  // 曜日配列
  const youbi_list = ["日","月","火","水","木","金","土"]

// 表示件数
const gyo_count = ref(store.state.gyo_count)

// スマホの時は１ページ目かつ全件（10000）
if (document.getElementById("app").clientWidth < 962) {
  
  current_page.value = 1
  gyo_count.value = 10000
}

// 表示件数を変えたら保持
const gyo_change = ()  => {
  store.state.gyo_count = gyo_count.value

  // 1ページ目に戻す
  top()
}

const st = ref(1)

let ed = ref(Math.min(parseInt(gyo_count.value), program.value.length+1))
const tm = computed(() => {
    st.value = 1
    ed.value = Math.min(parseInt(gyo_count.value), program.value.length+1);
    return Math.ceil(program.value.length / parseInt(gyo_count.value));
})
//-------- ページネーション -------------------
const top     = ()  => { st.value = 1
                         ed.value = st.value+parseInt(gyo_count.value)-1
                         current_page.value = 1
                         emit('call',{ cmd:'scroll_position_reset' })
                         page_change(1)                          }
const back    = ()  => { st.value = Math.max(1,st.value-parseInt(gyo_count.value))
                         ed.value = st.value+parseInt(gyo_count.value)-1 
                        let set_page = current_page.value
                        // 現在ページ数から1引いたら0にならない場合はマイナスする
                        if( (set_page-1 ) != 0){
                          set_page = set_page - 1
                        }
                         emit('call',{ cmd:'scroll_position_reset' })
                         page_change(set_page)}
const page    = (i) => { st.value = (i-1)*parseInt(gyo_count.value)+1;
                         ed.value = Math.min(i*parseInt(gyo_count.value), program.value.length+1);
                         emit('call',{ cmd:'scroll_position_reset' })
                         page_change(i)}
const forward = ()  => { st.value += parseInt(gyo_count.value);

                         let set_page = current_page.value

                         // 加算後の表示件数が全件数を超える場合は減算して戻す
                         if (st.value > program.value.length) { 
                          st.value -= parseInt(gyo_count.value)
                         }else{
                          // 加算後の表示件数が全件数を超えない場合はページを加算する
                          set_page = set_page + 1
                         }
                         ed.value = Math.min( st.value+parseInt(gyo_count.value)-1, program.value.length) 
                         emit('call',{ cmd:'scroll_position_reset' })
                         page_change(set_page)}
const last    = ()  => { st.value = Math.max(1,program.value.length-parseInt(gyo_count.value)+1)
                         ed.value = Math.min(st.value+parseInt(gyo_count.value), program.value.length) 
                         emit('call',{ cmd:'scroll_position_reset' })
                         // 全件数 / 表示件数を切り上げたものが最後のページ
                         page_change(Math.ceil(program.value.length / parseInt(gyo_count.value)))}
setTimeout(function(){ page(current_page.value) }, "100");

let page_change = function(page){
  current_page.value = page
  store.state.current_page = page
}

//------------------- 締切日を過ぎていれば赤で表示する
const over = (pg,nittei) => {

  let today = new Date()

  // 日程オーバーフラグ（初期値はtrue：オーバーしている）
  let return_nittei_over = true
  // 日程が全て終わっているか確認
  for(let n = 0;n<nittei.length;n++){
    let check_nittei = nittei[n]
    // 日程の終了日を取得
    let end = new Date(check_nittei.kaisai_end)
      end = end.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
      end = new Date(end);
      end.setHours(end.getHours()-9);

      console.log(end+"/"+today)
      // 終了日が今日以降ならfalse
      if (end >= today) {
          return_nittei_over = false
      }
  }

  if(return_nittei_over == true) return return_nittei_over

  // 一旦事業単位の受付〆切日を格納
  let check_shimekiri = new Date()

  // 受付〆切日種別が2（プログラム単位）かつプログラムに〆切日が設定されてる場合はそちらを確認する
  if(end_shubetsu.value == 2 && pg.shimekiri_date){
    let shimekiri = new Date(pg.shimekiri_date)
      shimekiri = shimekiri.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
      shimekiri = new Date(shimekiri);
      shimekiri.setHours(shimekiri.getHours()-9);
      check_shimekiri = shimekiri
   // check_shimekiri = EuShimekiriSetting(pg.shimekiri_date)
  }else if(end_shubetsu.value == 1){
      // 受付〆切日種別が1（事業単位）なら事業単位の日付を入力
      check_shimekiri = ShimekiriSetting(end_datetime.value)
    
  }else{
    // 受付〆切日種別が2（プログラム単位）かつプログラムに〆切日が設定されていない場合は、設定された「〇日前」と今日の日付によってチェック

    let shimakiri_nissu = pg.shimekiri_nissu

    // 日程のうち、最初の番地の開催終了日を入力
    let end_date = new Date(nittei[0].kaisai_end)

    for(let n = 0;n<nittei.length;n++){
      // 最初の番地以外の開催終了日も確認し、日付が一番後ろのものを格納
      if(n != 0){
        let nittei_end_date = new Date(nittei[n].kaisai_end)
        if(end_date < nittei_end_date){
          end_date = nittei_end_date
        }
      }
    }

    // 今日の日付を取得
    let today = new Date()
    today = today.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    today = new Date(today)
    today.setHours(0, 0, 0, 0);//0時0分0秒に設定

    // 最終的に取得した開催終了日のロケールと時刻をセット
    end_date = end_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    end_date = new Date(end_date)
    end_date.setHours(0, 0, 0, 0);//0時0分0秒に設定

    
    // 開催日と今日の日付を比較して日数を取得
    let checkDay = (end_date - today) / 86400000 ;

    // 設定された「開催日より〇日前」を下回るのであれば〆切
    if (checkDay < shimakiri_nissu) {
      return true
    }else{
      return false
    }
  }

  if (check_shimekiri >= today) {
      return false
  } else {
      return true
  }
}


//------------------- 締切日を過ぎていれば受付終了表示をする（プログラム内の活動全てチェック）
const all_over = (pg,sub_list,nittei,sub_nittei) => {


  let today = new Date()

  // 日程オーバーフラグ（初期値はtrue：オーバーしている）
  // 1つでも終了日以前なら、全体としてはオーバーしていないとする（一度でもfalseになったら塗り替えない）
  let return_nittei_over = true
  // 日程が全て終わっているか確認
  for(let n = 0;n<nittei.length;n++){
    let check_nittei = nittei[n]
    // 日程の終了日を取得
    let end = new Date(check_nittei.kaisai_end)
      end = end.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
      end = new Date(end);
      end.setHours(end.getHours()-9);

      console.log(end+"/"+today)
      // 終了日が今日以降ならfalse
      if (end >= today) {
          return_nittei_over = false
      }
  }

  // 活動2以降がある場合
  if(sub_list){
    for(let s = 0;s<sub_list.length;s++){
      for(let n = 0;n<sub_nittei[s].length;n++){
          let check_nittei = sub_nittei[s][n]
          // 日程の終了日を取得
          let end = new Date(check_nittei.kaisai_end)
          end = end.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
          end = new Date(end);
          end.setHours(end.getHours()-9);

          console.log(end+"/"+today)
          // 終了日が今日以降ならfalse
          if (end >= today) {
              return_nittei_over = false
          }
      }
    }
  }

  if(return_nittei_over == true) return return_nittei_over



  // 〆切日オーバーフラグ（初期値はtrue：オーバーしている）
  // 1つでも〆切に差し掛かってなかったら、全体としてはオーバーしていないとする（一度でもfalseになったら塗り替えない）
  let shimekiri_all_over = true

  // 一旦事業単位の受付〆切日を格納
  let check_shimekiri = new Date()

  // 活動1のチェック
  // 受付〆切日種別が2（プログラム単位）かつプログラムに〆切日が設定されてる場合はそちらを確認する
  if(end_shubetsu.value == 2 && pg.shimekiri_date){
    let shimekiri = new Date(pg.shimekiri_date)
      shimekiri = shimekiri.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
      shimekiri = new Date(shimekiri);
      shimekiri.setHours(shimekiri.getHours()-9);
      check_shimekiri = shimekiri
   // check_shimekiri = EuShimekiriSetting(pg.shimekiri_date)
   
      console.log(check_shimekiri+"/"+today)
      if (check_shimekiri >= today) {
          shimekiri_all_over = false
      }
  }else if(end_shubetsu.value == 1){
      // 受付〆切日種別が1（事業単位）なら事業単位の日付を入力
      check_shimekiri = ShimekiriSetting(end_datetime.value)
      
      console.log(check_shimekiri+"/"+today)
      if (check_shimekiri >= today) {
          shimekiri_all_over = false
      }
  }else{
    // 受付〆切日種別が2（プログラム単位）かつプログラムに〆切日が設定されていない場合は、設定された「〇日前」と今日の日付によってチェック

    let shimakiri_nissu = pg.shimekiri_nissu

    // 日程のうち、最初の番地の開催終了日を入力
    let end_date = new Date(nittei[0].kaisai_end)

    for(let n = 0;n<nittei.length;n++){
      // 最初の番地以外の開催終了日も確認し、日付が一番後ろのものを格納
      if(n != 0){
        let nittei_end_date = new Date(nittei[n].kaisai_end)
        if(end_date < nittei_end_date){
          end_date = nittei_end_date
        }
      }
    }

    // 今日の日付を取得
    let today = new Date()
    today = today.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    today = new Date(today)
    today.setHours(0, 0, 0, 0);//0時0分0秒に設定

    // 最終的に取得した開催終了日のロケールと時刻をセット
    end_date = end_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    end_date = new Date(end_date)
    end_date.setHours(0, 0, 0, 0);//0時0分0秒に設定

    
    // 開催日と今日の日付を比較して日数を取得
    let checkDay = (end_date - today) / 86400000 ;

    
      console.log(end_date+"/"+today)

    // 設定された「開催日より〇日前」を下回るのであれば〆切
    if (checkDay < shimakiri_nissu) {
    }else{
      shimekiri_all_over = false
    }
  }


  // 活動2以降がある場合
  if(sub_list){
    for(let s = 0;s<sub_list.length;s++){

      // 一旦事業単位の受付〆切日を格納
      let s_check_shimekiri = new Date()
      
      // 活動を一つずつ取り出す
      let spg = sub_list[s]

      // 活動1のチェック
      // 受付〆切日種別が2（プログラム単位）かつプログラムに〆切日が設定されてる場合はそちらを確認する
      if(end_shubetsu.value == 2 && spg.shimekiri_date){
        let shimekiri = new Date(spg.shimekiri_date)
        shimekiri = shimekiri.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        shimekiri = new Date(shimekiri);
        shimekiri.setHours(shimekiri.getHours()-9);
        s_check_shimekiri = shimekiri
        if (s_check_shimekiri >= today) {
            shimekiri_all_over = false
        }
      }else if(end_shubetsu.value == 1){
          // 受付〆切日種別が1（事業単位）なら事業単位の日付を入力
          s_check_shimekiri = ShimekiriSetting(end_datetime.value)
        if (s_check_shimekiri >= today) {
            shimekiri_all_over = false
        }
      }else{
        // 受付〆切日種別が2（プログラム単位）かつプログラムに〆切日が設定されていない場合は、設定された「〇日前」と今日の日付によってチェック
        let shimakiri_nissu = spg.shimekiri_nissu

        // 日程のうち、最初の番地の開催終了日を入力
        let end_date = null

        
        for(let n = 0;n<sub_nittei[s].length;n++){
          // 最初の番地以外の開催終了日も確認し、日付が一番後ろのものを格納
          if(n != 0){
            let nittei_end_date = new Date(sub_nittei[s].kaisai_end)
            if(end_date != null && end_date < nittei_end_date){
              end_date = nittei_end_date
            }
          }
        }

        if(end_date == null){
          end_date = new Date("9999-12-31")
        }

        // 今日の日付を取得
        let today = new Date()
        today = today.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        today = new Date(today)
        today.setHours(0, 0, 0, 0);//0時0分0秒に設定

        // 最終的に取得した開催終了日のロケールと時刻をセット
        end_date = end_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        end_date = new Date(end_date)
        end_date.setHours(0, 0, 0, 0);//0時0分0秒に設定

        
        // 開催日と今日の日付を比較して日数を取得
        let checkDay = (end_date - today) / 86400000 ;

        // 設定された「開催日より〇日前」を下回るのであれば〆切
        if (checkDay < shimakiri_nissu) {
        }else{
          shimekiri_all_over = false
        }
      }

    }
  }


  return shimekiri_all_over
}


// 各プログラムの定員がオーバーしていないかをチェックする
const teiin_over = (nittei_list,sub_nittei_list,pg,spg_list) => {

  let userdata = Sankasha.taikenusers
  let usercount = Sankasha.jisseki_all_user

  console.log(userdata)
  console.log(usercount)
  if(!userdata || userdata.length == 0){
    // 申込が１件もなければオーバーしていない
    return false
  }

  // 定員オーバーフラグ（初期値はtrue：オーバーしている）
  // 1つでも定員に差し掛かってなかったら、全体としてはオーバーしていないとする（一度でもfalseになったら塗り替えない）
  let teiin_all_over = true

  // 種別が施設・地域のプログラムの場合は、日程ごとの定員と1日ごとの参加者を照らし合わせてチェック
  if(pg.shubetsu == 1){
    const check_today = new Date()
    let set_date = new Date(check_today);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    const today = new Date(set_date);


    // 活動1のチェック
    if(nittei_list){
      // 日程レコードから申込める日時を抽出する
      nittei_list.forEach(function(nittei) {

        let nittei_teiin = nittei["teiin"] // 日程の定員
        
        // 1日ごとの場合は塗り替える
        if(pg.teiin_settei == 1){
          nittei_teiin = pg.teiin_oneday
        }
        let taiken_id = nittei["taiken_id"]

        // 開催日（自・至）から日数を求める
        let start_date = new Date(nittei["kaisai_start"]);
        const end_date = new Date(nittei["kaisai_end"] );
        // 差日を求めた上で＋1することで日数になる
        const termDay = ((end_date - start_date) / 86400000) + 1;

        // 申込める時間帯を取得
        const jikantai_start = nittei["jikantai_start"]
        // const jikantai_end = nittei["jikantai_end"]

        // 開催曜日を取得
        let kaisai_list = []
        if(nittei["kaisai_youbi"] != "" && nittei["kaisai_youbi"] != null){
          nittei["kaisai_youbi"] = nittei["kaisai_youbi"].replace(/､/g, '、')
          kaisai_list = nittei["kaisai_youbi"].split("、")
        }
        // 除外曜日を取得
        let jogai_list = []
        if(nittei["jogai"] != "" && nittei["jogai"] != null){
          nittei["jogai"] = nittei["jogai"].replace(/､/g, '、')
          jogai_list = nittei["jogai"].split("、")
        }
        
        // 除外日を取得
        let jogai_date = []
        if(nittei["jogai_date"] != "" && nittei["jogai_date"] != null){
          jogai_date = nittei["jogai_date"].split("、")
        }
        for(let i = 0;i < termDay;i++){
          let date = new Date();
          if(i != 0) {
            date = start_date.setDate(start_date.getDate() + 1);
          }else{
            date = start_date.setDate(start_date.getDate());
          }
          let set_date = new Date(date)
          set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
          set_date = new Date(set_date)
          set_date.setHours(0, 0, 0, 0);//0時0分0秒に設定
          
          // 日付が今日より後ならチェック
          if(today < set_date){
            let set_year = set_date.getFullYear()
            let set_month = set_date.getMonth() + 1
            let set_day = set_date.getDate()
            let set_youbi = set_date.getDay()

            let moushikomibi = set_year+"/"+set_month+"/"+set_day
            let jogai_day = set_month+"/"+set_day
            
            
            // 開催曜日の指定がある場合
            if(kaisai_list.length != 0){
                
              // 開催曜日に指定した曜日に該当する日の場合はそのまま追加
              if(kaisai_list.includes(youbi_list[set_youbi])) {

              }else{

                // 開催曜日に祝日がある場合
                if(kaisai_list.includes("祝")){
                  // 日付が祝日かどうかを確認
                  // 祝日でなければスルー
                  if(!holiday_list.includes(moushikomibi)) continue
                  
                }else{
                    continue
                }
              }
            }

            // 除外曜日の指定がある場合
            if(jogai_list.length != 0){
              // 除外曜日に指定した曜日に該当する日の場合
              // 飛ばして次へ
              if(jogai_list.includes(youbi_list[set_youbi])) continue

              // 除外曜日に祝日がある場合
              if(jogai_list.includes("祝")){
                // 日付が祝日かどうかを確認
                // 祝日であれば飛ばして次へ
                if(holiday_list.includes(moushikomibi)) continue
                
              }
            }

            // 除外日の指定がある場合
            if(jogai_date.length){
              
              // 除外日に該当する日の場合
              // 飛ばして次へ
              if(jogai_date.includes(jogai_day)) continue
            }

            
            // この申込日時を追加すべきかどうか（0：追加する、1：追加しない）
            let add_flg = 0
     
            // チェックが必要ない日時であれば飛ばして次へ
            if(add_flg == 0){ 
              // 該当日時の参加者の数をチェック
              if(userdata.length != 0){
                
                let count_ninzu = 0
                for(let j = 0;j<userdata.length;j++){
                  let program_id = userdata[j].program_id
                  let kaisai_date = new Date(userdata[j].kaisai_date) 
                  kaisai_date.setHours(0, 0, 0, 0);//0時0分0秒に設定
                  let kaisai_jikantai_start = userdata[j].jisseki_jikantai_start

                  // 合致するプログラムIDが存在する
                  if(program_id == taiken_id){
                    // 合致する開催日が存在する
                    if(kaisai_date.getTime() == set_date.getTime()){
                      // 合致する時間帯が存在するなら人数を増やす
                      if(kaisai_jikantai_start == jikantai_start){
                          count_ninzu = count_ninzu + 1
                      }
                    }
                  }
                }
                
                // 参加者が定員より下回ったら満員ではない（false）
                if(nittei_teiin > count_ninzu){
                  teiin_all_over = false
                }
              }
            }
          }
        }
        
      });
    }

    // 活動2以降のチェック
    if(sub_nittei_list){
      for(let s = 0;s<sub_nittei_list.length;s++){
        // 活動ごとにチェック
        let sub_nittei = sub_nittei_list[s]
        let spg = spg_list[s]
        

        // 日程レコードから申込める日時を抽出する
        sub_nittei.forEach(function(nittei) {

          let nittei_teiin = nittei["teiin"]
          // 1日ごとの場合は塗り替える
          if(spg.teiin_settei == 1){
            nittei_teiin = spg.teiin_oneday
          }
          let taiken_id = nittei["taiken_id"]
            
          // 開催日（自・至）から日数を求める
          let start_date = new Date(nittei["kaisai_start"]);
          const end_date = new Date(nittei["kaisai_end"] );
          // 差日を求めた上で＋1することで日数になる
          const termDay = ((end_date - start_date) / 86400000) + 1;

          // 申込める時間帯を取得
          const jikantai_start = nittei["jikantai_start"]
          // const jikantai_end = nittei["jikantai_end"]

          // 開催曜日を取得
          let kaisai_list = []
          if(nittei["kaisai_youbi"] != "" && nittei["kaisai_youbi"] != null){
            nittei["kaisai_youbi"] = nittei["kaisai_youbi"].replace(/､/g, '、')
            kaisai_list = nittei["kaisai_youbi"].split("、")
          }
          // 除外曜日を取得
          let jogai_list = []
          if(nittei["jogai"] != "" && nittei["jogai"] != null){
            nittei["jogai"] = nittei["jogai"].replace(/､/g, '、')
            jogai_list = nittei["jogai"].split("、")
          }
          
          // 除外日を取得
          let jogai_date = []
          if(nittei["jogai_date"] != "" && nittei["jogai_date"] != null){
            jogai_date = nittei["jogai_date"].split("、")
          }
          for(let i = 0;i < termDay;i++){
            let date = new Date();
            if(i != 0) {
              date = start_date.setDate(start_date.getDate() + 1);
            }else{
              date = start_date.setDate(start_date.getDate());
            }
            let set_date = new Date(date)
            set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
            set_date = new Date(set_date)
            set_date.setHours(0, 0, 0, 0);//0時0分0秒に設定

            // 日付が今日より後ならチェック
            if(today < set_date){
              let set_year = set_date.getFullYear()
              let set_month = set_date.getMonth() + 1
              let set_day = set_date.getDate()
              let set_youbi = set_date.getDay()

              let moushikomibi = set_year+"/"+set_month+"/"+set_day
              let jogai_day = set_month+"/"+set_day
              
              
              // 開催曜日の指定がある場合
              if(kaisai_list.length != 0){
                  
                // 開催曜日に指定した曜日に該当する日の場合はそのまま追加
                if(kaisai_list.includes(youbi_list[set_youbi])) {

                }else{

                  // 開催曜日に祝日がある場合
                  if(kaisai_list.includes("祝")){
                    // 日付が祝日かどうかを確認
                    // 祝日でなければスルー
                    if(!holiday_list.includes(moushikomibi)) continue
                    
                  }else{
                      continue
                  }
                }
              }

              // 除外曜日の指定がある場合
              if(jogai_list.length != 0){
                // 除外曜日に指定した曜日に該当する日の場合
                // 飛ばして次へ
                if(jogai_list.includes(youbi_list[set_youbi])) continue

                // 除外曜日に祝日がある場合
                if(jogai_list.includes("祝")){
                  // 日付が祝日かどうかを確認
                  // 祝日であれば飛ばして次へ
                  if(holiday_list.includes(moushikomibi)) continue
                  
                }
              }

              // 除外日の指定がある場合
              if(jogai_date.length){
                
                // 除外日に該当する日の場合
                // 飛ばして次へ
                if(jogai_date.includes(jogai_day)) continue
              }

              
              // この申込日時を追加すべきかどうか（0：追加する、1：追加しない）
              let add_flg = 0
              

              // 開催日と今日の日付を比較して日数を取得
              var checkDay = (set_date - today) / 86400000 ;

              let set_nissu = 1
  /*
              // 受付〆切日時がプログラム単位の場合
              if(end_shubetsu.value == 2){
                  // 受付〆切日が設定されていない場合
                  if(!taiken_list.shimekiri_date){
                      set_nissu = taiken_list.shimekiri_nissu
                  }
              }
              
              if (checkDay < set_nissu) {
                  add_flg = 1
                  
              }*/

              // チェックが必要ない日時であれば飛ばして次へ
              if(add_flg == 0){ 
                // 該当日時の参加者の数をチェック
                if(userdata.length != 0){
                  let count_ninzu = 0
                  for(let j = 0;j<userdata.length;j++){
                    let program_id = userdata[j].program_id
                    let kaisai_date = new Date(userdata[j].kaisai_date) 
                    kaisai_date.setHours(0, 0, 0, 0);//0時0分0秒に設定
                    let kaisai_jikantai_start = userdata[j].jisseki_jikantai_start

                    // 合致するプログラムIDが存在する
                    if(program_id == taiken_id){
                      // 合致する開催日が存在する
                      
                      if(kaisai_date.getTime() == set_date.getTime()){
                        // 合致する時間帯が存在するなら人数を増やす
                        if(kaisai_jikantai_start == jikantai_start){
                            count_ninzu = count_ninzu + 1
                        }
                      }
                    }
                  }
                  
                  // 参加者が定員より下回ったら満員ではない（false）
                  if(nittei_teiin > count_ninzu){
                    teiin_all_over = false
                  }
                }
              }
            }
          }
          
        });
      }
    }
  }else{
    // 制作・寄付プログラムの場合は、プログラムに設定された全体の定員と、参加数を単純比較

    if(userdata.length != 0){
       let count_ninzu = 0
       for(let j = 0;j<userdata.length;j++){
          let program_id = userdata[j].program_id
          // 合致するプログラムIDが存在する
          if(program_id == pg.taiken_id){
              count_ninzu = count_ninzu + 1
          }
        }
        // 参加者が定員より下回ったら満員ではない（false）
        if(pg.seisaku_teiin > count_ninzu){
          teiin_all_over = false
        }
    }
  }

  // 最後に、「施設・地域」のプログラムで「全体の定員を利用する」場合のチェック
  // この処理で引っかかったら、他の条件で申込可能でも、ここで申込不可とする
  if(pg.shubetsu == 1){
    if(pg.all_teiin_flg == 1){
      let program_count = 0
      if(usercount){
          for(let j = 0;j<usercount.length;j++){
            // 同じ体験プログラムIDを持つものだけカウント
            if(usercount[j].main_taiken_id == pg.taiken_id){
              program_count += usercount[j].length
            }
          }
      }
      
      if(program_count >= pg.seisaku_teiin){
          teiin_all_over = true
      }
    }

  }

  return teiin_all_over
}

   // 総申込者数を取得する
    let count_read_error = 0
    let moshikomi_count_read = function(set_choson_code,moshikomi_count,moshikomi_flg) { 
        let set_url = GlobalData.$API_URL + "Taikenuser_moshikomi_count"
        axios.post(set_url,
        {choson_code:set_choson_code})  //市区町村コードを指定
        .then(response => {

          // 総申込者数を利用する場合、全てこのタイミングで代入
          now_moshikomi_count.value = response.data.count
          all_moshikomi_count.value = moshikomi_count
          all_moshikomi_flg.value = moshikomi_flg
      
        })
        .catch(error => {
            if(count_read_error == 6){
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "get_error";
                contentMessage.value = MessageModal
            }else{
                count_read_error++
                setTimeout(function(){moshikomi_count_read(set_choson_code,moshikomi_count,moshikomi_flg)},"1000")
            }
        })
    }

//------------------- 体験プログラム詳細表示へ
const shosai = (i,teiin_flg) => { 

  // 総申込者数を利用するかしないかわからない場合はいったんreturn
  if(all_moshikomi_flg.value == 0){
    return
  }else if(all_moshikomi_flg.value == 1){
    // 総申込者数を利用する場合
    // 体験者が申し込んでいない場合
    if(user_ok_jyokyo.value.length == 0){
      // 総申込者数が現在の申込者数以下の場合は申込不可
      if(all_moshikomi_count.value <= now_moshikomi_count.value){
        return
      }
    }
  }

  // 総申込者数を利用する場合、「体験ユーザーがすでに申込済」、または、「体験ユーザーが申し込んでいない、かつ、総申込者数が現在の申込者数を上回る」場合はこれ以降の処理を行う
  // または、総申込者数を利用しない場合はこれ以降の処理を行う

  let today = new Date()

  let check_shimekiri = new Date()

  // アンケート未回答の場合は入れない
  if(enqete_ok.value == 0){
    message.value = GlobalData.$enqete_mikaitou
    message_cat.value = 0;
    message_flag.value = true;
    message_method.value = "enqete_error";
    contentMessage.value = MessageModal
    return
  }
  

   // if (check_shimekiri >= today) {

      let sanka_flg = 0 // 1:申込済みかつ未参加、2:申込済みかつ仮予約
      let sanka_count = 0
      let before_id = 0
      // 締切前なら体験プログラムの申込み状況を確認
      // ついでに申込済みの体験プログラムをカウント
      for(let u = 0;u<user_taiken_jyokyo.value.length;u++){

        if(user_taiken_jyokyo.value[u].jokyo != 9){

          if(program.value[i+st.value-1].taiken_id == user_taiken_jyokyo.value[u].main_taiken_id){
            // 仮予約（キャンセル待ち）のものがあれば申込不可
            if(user_taiken_jyokyo.value[u].jokyo == '0'){
              sanka_flg = 2
            }
            // 未参加のものがあれば申込不可
            if(user_taiken_jyokyo.value[u].jokyo == '1'){
              
              // 仮予約（キャンセル待ち）を優先
              if(sanka_flg != 2){
                sanka_flg = 1
              }
            }
          }
          
          if(before_id != user_taiken_jyokyo.value[u].main_taiken_id){
            if(user_taiken_jyokyo.value[u].program_kbn == 1){
              sanka_count++
            }
          }
          before_id = user_taiken_jyokyo.value[u].main_taiken_id
        }
      }

      if(sanka_flg > 0){
        // 申込済、または、仮予約（キャンセル待ち）なら詳細ページへの進入不可
        message.value = "このプログラムは仮予約中です。"
        // 申込済みの場合のメッセージ
        if(sanka_flg == 1){
            message.value = "このプログラムは申込済です。\n\n※全日程の活動終了後、再度申込みできます。"
        }
        message_cat.value = 0;
        message_flag.value = true;
        message_method.value = "read_error";
        contentMessage.value = MessageModal

      }else{

        // 申込み回数の上限が決まっている場合
        if(program_shubetsu.value == 1){

          // 申込み回数がすでに上限以上の場合は進入不可
          if(program_count.value <= sanka_count ){
            message.value = "申込回数の上限に達しています。\n※このプログラムに参加したい場合は、他のプログラムを１つキャンセルする必要があります。"
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "read_error";
            contentMessage.value = MessageModal
            return
          }

        }
        
        // 親コンポーネントでスクロール位置を保存する
        emit('call',{cmd:'scroll_position'});
        router.push('/'+cityname+'/Taiken/detail/'+(program.value[i+st.value-1].taiken_id)) 

      }

   // }
  
}

  // 参加条件の大小をチェック（先に来る区分が小さくなければならない）
  function kubunCheck(start,end){
    if (!start) return 1;

    const [startKubun] = start;
    const startOrder = joken_kubun_name[startKubun];

    let endOrder = null;

    if (end) {
      const [endKubun] = end;
      endOrder = joken_kubun_name[endKubun];
    }

    // 区分大小チェック（start > end は不正なのでここで終了）
    if (endOrder !== null && startOrder > endOrder) {
      return 1 
    }
    return 0

  }

  // 参加条件をテキスト化
  function createJokenText(startText, endText) {

    if(!startText) return "小学生～一般"

    const STUDENT_LABEL = {
      '小': '小学生',
      '中': '中学生',
      '高': '高校生',
      '大': '大学生',
      '一般': '一般'
    };

    const SCHOOL_LABEL = {
      '小': '小学',
      '中': '中学',
      '高': '高学',
      '大': '大学'
    };

    const parse = (text) => {
      const [kubun, gradeStr] = text.split(':');
      return { kubun, grade: Number(gradeStr) };
    };
    const start = parse(startText);
    const end = parse(endText);

    // 一般のみ
    if (start.kubun === '一般' && end.kubun === '一般') {
      return '一般';
    }

    // 開始と終了が異なる → 常に「～」
    if (startText !== endText) {
      const startLabel =
        start.grade > 0
          ? `${SCHOOL_LABEL[start.kubun]}${start.grade}年生`
          : STUDENT_LABEL[start.kubun];

      const endLabel =
        end.grade > 0
          ? `${SCHOOL_LABEL[end.kubun]}${end.grade}年生`
          : STUDENT_LABEL[end.kubun];

      return `${startLabel}～${endLabel}`;
    }

    // 同一区分・同一学年
    if (start.grade > 0) {
      return `${SCHOOL_LABEL[start.kubun]}${start.grade}年生`;
    }

    // 同一区分・学年なし
    return STUDENT_LABEL[start.kubun];
  }

  // joken_all_startとjoken_all_endのテキストを分解
  function parseKubunText(text) {
    const [kubun, gradeStr] = text.split(':');
    return {
      kubun,
      grade: Number(gradeStr)
    };
  }



// お知らせへ移動
let move_notification = function(){
  
  router.push('/'+cityname+'/Taiken/notification') 
}

// ユーザー登録後アンケートへ移動
let move_enqete = function(){
  router.push('/'+cityname+'/Taiken/enqete/1') 

}


    // メッセージを表示するウィンドウでOKを押された時
    let OK_message = function(){ 
        Close_message();//メッセージを表示するウィンドウを閉じる
        
        if(message_method.value == "enqete_error"){
            // アンケート未回答の場合はアンケート画面へ
            move_enqete()
        }
    }

    // メッセージを表示するウィンドウを閉じる
    let Close_message = function(){
        message_flag.value = false;
        contentMessage.value = null
    }


//------------------- Googlemap（外部リンク）へ
const googlemap = (set_jusho) => { window.open("http://local.google.co.jp/maps?q="+set_jusho,"_blank") }

const dist = (e) => {
    alert("dist:"+e.clientX+","+e.clientY+" left,bottom:"+drg.value.left+","+drg.value.clientTop)
}
const home = () => { 
  // 体験フローが１（事前説明会を先に申込む）の場合はHOME画面へ戻す
  if(GlobalData.$taiken_flow == 1){
    router.push('/'+cityname+'/Taiken')
  }else{
    // 体験フローが２の場合は、この画面がHOMEなのでページを１に戻す
    store.state.current_page = 1;
    page(1)
  }
 }

const jizen_list = () =>{
  router.push('/'+cityname+'/Taiken/Jizen')
  
}

const login = function() {
   router.replace('/'+cityname+'/Taiken/login')
}

const user_signin = () => {
    router.replace('/'+cityname+'/Taiken/user_signin' )
}

// 所属社協へ移動する
const move_shozoku = () =>{
    location.href=location.protocol+'//'+location.host+"/"+GlobalData.shakyo_code+"/Taiken"
}

/* 初期処理 */
let user_taiken_jyokyo = ref([])//ユーザーの体験プログラム申込状況を取得
let user_ok_jyokyo = ref([])//ユーザーの体験プログラム申込状況のうち、キャンセルを除いたもの
if (GlobalData.$User_email) { // ログインしているかチェック
    if (GlobalData.user_id) { // ユーザー情報があるかチェック
            
        // ログイン中かつユーザー情報登録済みであればこのユーザーの体験プログラムの実績データを取得
        axios.post(GlobalData.$API_URL + "Taikenuser_Jisseki",
        {
           taikenuser_id: GlobalData.user_id,
           program_kbn:1
        },GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {
          if(response.data["status"] == 1){
            alert("エラーが発生しました。\n"+response.data["message"])
          }else{
              user_taiken_jyokyo.value = response.data.jisseki
              // キャンセルを除いたものを抽出
              for(let u = 0;u<user_taiken_jyokyo.value.length;u++){
                if(user_taiken_jyokyo.value[u].jokyo != '9'){
                  user_ok_jyokyo.value[user_ok_jyokyo.value.length] = user_taiken_jyokyo.value[u]
                }
                
              }

          }
        }).catch(error => {
          
        })
      }
    }else{
      login_status.value = false
    }

    // 表示設定と受付〆切日、申込キャンセルに関する情報、社協名を取得
    axios.post(GlobalData.$API_URL+"Shakyo_read", 
            {shakyo:route.params.shakyo}
            ).then(response => {
           
              // 表示設定を取得
              list_disp.value = response["data"].program_list_disp.split(',')
              list_color.value = response["data"].program_list_color.split(',')
              list_bold.value = response["data"].program_list_bold.split(',')

              // 社協名を取得
              shakyo_name = response["data"].shakyo_name

              // 受付〆切日の種別を取得
              end_shubetsu.value = response["data"].end_shubetsu
              


            // 受付〆切日の確認
            if(response["data"].end_date){

              let set_time = " 23:59:59"
              if(response["data"].end_time != "" && response["data"].end_time != null) {
                set_time = response["data"].end_time
              }
              let end_date = new Date(response["data"].end_date + " "+set_time)
              end_date = end_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
              end_date = new Date(end_date);
              end_date.setHours(end_date.getHours());

              end_datetime.value = end_date

            }else{
              // 存在しない場合は今日の23時59分59秒まで

            }

            // 申込み可能回数の確認
            if(response["data"].program_shubetsu == 1){
              program_shubetsu.value = response["data"].program_shubetsu
              program_count.value = response["data"].program_count

            }

              /*
              // キャンセルに関する情報
              let cancel_count = 0 // 申込キャンセル可能回数 0はキャンセル不可
              let cancel_day = 1 // 申込キャンセル可能日数
              let cancel_setting = 0 // キャンセル待ち機能 0：利用する、1：しない
              */
              cancel_count = response["data"].cancel_count
              cancel_day = response["data"].cancel_day
              cancel_setting = response["data"].cancel_setting

              

            // 総申込者数を利用する場合
            if(response["data"].all_moshikomi_flg == 1){
              moshikomi_count_read(route.params.shakyo,response["data"].all_moshikomi_count,response["data"].all_moshikomi_flg)
            }else{
              all_moshikomi_flg.value = response["data"].all_moshikomi_flg
            }

            GlobalData.enqete_flg = 2 //アンケート回答フラグを一度「必要なし」に変更
            if (GlobalData.$User_email) { // ログインしているかチェック
              if (GlobalData.user_id) { // ユーザー情報があるかチェック
                // ユーザー登録後アンケートを利用する場合は回答しているかチェック
                if(response["data"].enqete_shubetsu == 1){
                  Form_answer_check()
                }
              }
            }

        })
        .catch(error => {
          
//            alert("社協情報の取得時にエラーが発生しました。"+error)
        })

    
    let jizen_dsp = ref(0)
    // 体験フロー１（事前説明会を先に申込む）の時は、申込める事前説明会があればボタンを表示
    if(GlobalData.$taiken_flow == 1){
      jizen_dsp.value = 1

      // 未ログインならボタン表示
      if(GlobalData.user_id == null){

      }else{
        // ログイン済みなら実績を確認し、事前説明会未参加であれば表示
        axios.post(GlobalData.$API_URL+"Taikenuser_Jisseki", {taikenuser_id:GlobalData.user_id}, GlobalData.$ID_Token)
        .then(response => {
            console.log("実績読取完了")
            let myjisseki = response.data.jisseki  // 全実績
            
            for(let j = 0;j<myjisseki.length;j++){
                let jisseki_kobetsu = myjisseki[j]
                // 実績にプログラム区分２（事前説明会）がある場合
                if(jisseki_kobetsu["program_kbn"] == 2){
                    // 1つでも参加済みの事前説明会があれば非表示とする
                    if(jisseki_kobetsu["jokyo"] == '2'){
                        jizen_dsp.value = 0
                    }
                }
            }
        })
        .catch(error => {
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        })
      }
        /*
        const today = new Date()
        let set_date = new Date(today);
        set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        set_date = new Date(set_date);
                
        let today_set = set_date.getFullYear()+"-"+(set_date.getMonth()+1)+"-"+set_date.getDate()

        // 今日以前に締め切った事前説明会は除く
        let search_param = {"shimekiri_date":today_set}
        search_param.choson_code = cityname

        axios.post(GlobalData.$API_URL+"Jizen_get", search_param)
        .then(response => {
            
            let jizen = response.data.jizen
            let jizen_kensu = 0
            // 締め切られていない事前説明会を取得
            if(jizen.length != 0){
                for(let i=0;i<jizen.length;i++){
                //   alert(JSON.stringify(program.value[i]))
                
                    let today = new Date()


                    let shimekiri = new Date(jizen[i].shimekiri_date +" 23:59:59")
                    
                    if (shimekiri >= today) {
                        jizen_kensu++
                    }
                }
            }


            // すべての事前説明会が締め切られていたらボタンは表示しない
            if(jizen_kensu == 0){
            }else{
                jizen_dsp.value = 1
            }
        
        })
        .catch(error => {
            
        })
        */
  }




  let manual_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/161c0be34f8f80fc87baf85432ed7220"
    window.open(url,"_blank")
}

// Q&Aを開く
const qanda_open = () =>{

  let url = "https://zest-newsprint-e3e.notion.site/Q-A-175c0be34f8f801998fac72f169fb66b"
  window.open(url,"_blank")
}     
// ユーザー切替え画面の表示
const multipleusers_change = () =>{
    emit('call', { cmd:'multipleprofile_switch',id:GlobalData.user_id})
}        
    
</script>
<style scoped>
.hov,.hov_over,.hov_over:hover {
  background-color: white;
  cursor: default;
}
.hov:hover {
  background-color:royalblue;
  cursor: pointer;

}

.list_bunrui {
  font-size: 14px;
}

.program_naiyo{
  width:90%;
  margin-left:10px
}

.midashi_pc {
  min-width:100px;
}
.midashi_sp{
  width:10%;
  min-width:100px;
}

@media screen and (min-width: 961px) {

/* PC版 */

  .sp_button_area{
      display: none
  }
}
@media screen and (max-width: 960px) {

  /* スマホ版 */

  .sp_button_area{
      display: flex
  }
}
</style>
